export default {"src":"/_next/static/media/7.73064570.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};